import { render, staticRenderFns } from "./RedirectToCheckoutDialog.vue?vue&type=template&id=2e5377f0&"
import script from "./RedirectToCheckoutDialog.vue?vue&type=script&lang=js&"
export * from "./RedirectToCheckoutDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5377f0')) {
      api.createRecord('2e5377f0', component.options)
    } else {
      api.reload('2e5377f0', component.options)
    }
    module.hot.accept("./RedirectToCheckoutDialog.vue?vue&type=template&id=2e5377f0&", function () {
      api.rerender('2e5377f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VaccineViews/VaccineRegistrationPage/components/RedirectToCheckoutDialog.vue"
export default component.exports